import { render, staticRenderFns } from "./project-group.component.vue?vue&type=template&id=3476945c&scoped=true&"
import script from "./project-group.component.vue?vue&type=script&lang=js&"
export * from "./project-group.component.vue?vue&type=script&lang=js&"
import style0 from "./project-group.component.vue?vue&type=style&index=0&id=3476945c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3476945c",
  null
  
)

export default component.exports